/** Normalize operator-entered pairing codes for claim. */
export function normalizePairingCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isValidPairingCode(code: string): boolean {
  return code.length >= 4 && code.length <= 12;
}
